import { z } from 'zod/v4';
// Platform roles (two-tier: admin inherits all operator capabilities)
export const PlatformRoleSchema = z.enum(['operator', 'admin']);
// Operator availability status (manual toggle)
export const OperatorStatusSchema = z.enum(['available', 'busy', 'away', 'offline']);
// Activity status (computed from API activity)
export const ActivityStatusSchema = z.enum(['active', 'idle', 'offline']);
// Operator profile (for platform staff)
export const OperatorProfileSchema = z.object({
    id: z.string().uuid(),
    userId: z.string().uuid(),
    platformRole: PlatformRoleSchema,
    status: OperatorStatusSchema,
    displayName: z.string(),
    email: z.string().email(),
    shiftStart: z.string().datetime().optional(),
    shiftEnd: z.string().datetime().optional(),
    maxWorkload: z.number().default(10),
    currentWorkload: z.number().default(0),
    lastActivityAt: z.string().datetime().optional(), // Last API call timestamp
    activityStatus: ActivityStatusSchema.optional(), // Computed from activity
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
export const CreateOperatorProfileSchema = OperatorProfileSchema.omit({
    id: true,
    createdAt: true,
    updatedAt: true,
    currentWorkload: true,
});
export const UpdateOperatorProfileSchema = OperatorProfileSchema.partial().omit({
    id: true,
    userId: true,
    createdAt: true,
});
